// @flow
import React, { Component } from 'react';

import MenuElement from 'components/header/MenuElement';
import MenuElementPlus from 'components/header/MenuElementPlus';
import { dynamicClassName } from 'utils/dynamicClassName';
import { withRouter } from 'react-router-dom';

export type StateProps = {
  subMenus: Array<string>
};

type Props = {
  onPageChanged: (id: number) => void
} & StateProps;

type ComponentState = {
  isMobile: boolean,
  hiddenMenuItems: Array<number>,
  menuLinkX: number,
  isOpen: boolean,
  menuIsActive: number
};

class SubMenuHeader extends Component<Props, ComponentState> {
  _menuElements: Array<?MenuElement>;
  _menu: ?HTMLElement;
  _menuLink: ?HTMLElement;
  state: ComponentState = {
    isMobile: false,
    hiddenMenuItems: [],
    menuLinkX: 0,
    isOpen: false,
    menuIsActive: 0
  };

  constructor(props: Props) {
    super(props);
    this._menuElements = [];
  }

  componentDidMount() {
    this.updateDimensions();
    window.addEventListener('resize', this.updateDimensions.bind(this));
  }

  componentDidUpdate(prevProps: Props) {
    this.updateDimensions();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDimensions.bind(this));
  }

  resetMenuElementRef = (c: ?MenuElement) => {
    this._menuElements = [];
    this.addMenuElementRef(c);
  };

  addMenuElementRef = (c: ?MenuElement) => {
    this._menuElements.push(c);
  };

  isDisplayed = (id: number) => {
    return !this.state.hiddenMenuItems.includes(id);
  };

  onHandleSubMenuMobile = () => {
    const { isOpen } = this.state;
    this.setState({
      isOpen: !isOpen
    });
  };

  updateDimensions() {
    const menu = this._menu;
    const menuLink = this._menuLink;
    if (menu && menuLink) {
      const menuLinkBounds: any = menuLink.getBoundingClientRect();
      const menuLinkX = menuLinkBounds.left;

      if (menuLinkX !== this.state.menuLinkX) this.setState({ menuLinkX });
      let maxWidth = menu.getBoundingClientRect().width - 123;

      if (maxWidth > 1157) {
        maxWidth -= 120;
      }

      const width_menu_links =
        this._menuElements.reduce((total, item) => (item ? total + item.getSize() : total), 0) +
        this._menuElements.length * 32;

      let currentWidth = width_menu_links;
      let deleted = [];
      if (maxWidth > 644) {
        for (let i = this._menuElements.length - 1; i > 0; i--) {
          if (currentWidth > maxWidth) {
            if (this._menuElements[i]) currentWidth -= this._menuElements[i].getSize();
            deleted = [...deleted, i];
          }
        }
        if (this.state.isMobile) this.setState({ isMobile: false });
      } else {
        if (!this.state.isMobile) this.setState({ isMobile: true });
      }
      if (
        (deleted.length !== this.state.hiddenMenuItems.length &&
          (deleted.length > 0 || this.state.hiddenMenuItems.length > 0) &&
          !deleted.every(id => this.state.hiddenMenuItems.includes(id))) ||
        !this.state.hiddenMenuItems.every(id => deleted.includes(id))
      ) {
        this.setState({ hiddenMenuItems: deleted });
      }
    }
  }

  activateMenu = (id: number) => {
    this.setState({
      menuIsActive: id,
      isOpen: false
    });
    this.props.onPageChanged(id);
  };

  renderMenu = () => {
    const { subMenus } = this.props;
    const { menuIsActive } = this.state;

    const test = subMenus.map((menu, index) => {
      return (
        <MenuElement
          url="#"
          title={menu}
          titleAll="Toute l'actualité"
          isMobile={false}
          ref={ref => (index === 0 ? this.resetMenuElementRef(ref) : this.addMenuElementRef(ref))}
          id={index}
          isDisplayed={this.isDisplayed}
          menuX={this.state.menuLinkX}
          activateMenu={this.activateMenu}
          isActive={index === menuIsActive}
          key={index}
        />
      );
    });
    return test;
  };

  render() {
    const { subMenus } = this.props;
    const { isOpen, isMobile, menuIsActive } = this.state;

    const titleClassName = dynamicClassName('accordion-trigger ft-up ');
    isOpen && subMenus.length > 1 && titleClassName.add('is-selected');

    const menuContainerClassName = dynamicClassName('navbar__wrapper accordion-panel ');
    (subMenus.length === 1 || (!isOpen && isMobile)) && menuContainerClassName.add('is-hidden');

    const hiddenMenuElements = this.state.hiddenMenuItems.map(id => {
      return this._menuElements[id];
    });

    return (
      <nav className="navbar navbar--green" ref={c => (this._menu = c)}>
        <a className={titleClassName.build()} onClick={this.onHandleSubMenuMobile}>
          {subMenus[menuIsActive]}
        </a>
        <div className={menuContainerClassName.build()}>
          <ul className="accordion-panel navbar__links" ref={c => (this._menuLink = c)}>
            {this.renderMenu()}
            <MenuElementPlus
              hiddenMenuElements={hiddenMenuElements}
              isMobile={this.state.isMobile}
              id={10}
              isDisplayed={this.isDisplayed}
              menuX={this.state.menuLinkX}
              text="En voir plus"
              isNavbar={true}
            />
          </ul>
        </div>
      </nav>
    );
  }
}

export default withRouter(SubMenuHeader);
